import React, { useState } from 'react';
import axios from 'axios';
import ExcelJS from 'exceljs';
import saveAs from 'file-saver';
import styles from './ReportCreationPanel.module.css';


const backendURL = /*'http://localhost:55555*/'/services';


async function callAPIEventListLV( unitID, startDateTime, endDateTime, differentiatior, offsetLV, isAll, groupLV) {
    let response;
    let url = backendURL + '/lugaresVisitados';
    let d = new Date;
    let body = {
        unitID: unitID,
        startDate: startDateTime,
        endDate: endDateTime,
        differentiator: differentiatior,
        offsetLV: offsetLV,
        timeOffset: d.getTimezoneOffset(),
        isAll: isAll,
        groupLV: groupLV
    }

    response = await axios.post(url, body);
    return response.data;
}

async function generateAndDownloadExcel(data) {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Reporte');


    //let d = new Date(1734967480 * 1000);
    //let locationFormat = 'es-MX';
    /*
    console.log(d.toLocaleString(locationFormat, {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
    }));
    */
    //console.log(d);

    worksheet.columns = [
        { header: 'Unidad', key: 'unidad', width: 15},
        { header: 'Fecha Inicial', key: 'horaInicial', width: 14},
        { header: 'Fecha Final', key: 'horaFinal', width: 14},
        { header: 'Día', key: 'diaBase', width: 15},
        //{ header: 'Fecha Inicial', key: 'diaInicio', width: 15},
        //{ header: 'Fecha Final', key: 'diaFinal', width: 15},
        { header: 'Evento', key: 'evento', width: 15},
        { header: 'Lugar Visitado', key: 'lugarVisitado', width: 45},
        { header: 'Duración', key: 'duracion', width: 13},
        
        //{ header: 'Punto Inicial', key: 'puntoInicial', width: 25},
        //{ header: 'Punto Final', key: 'puntoFinal', width: 25},
        { header: 'Ubicación en Mapa', key: 'ubicacion', width: 23},
    ];

    ['A1','B1','C1','D1','E1','F1','G1','H1'/*,'I1','J1','K1'*/].map(cell => {
        worksheet.getCell(cell).style = {
            font: {
                bold: true,
                size: '12',
                color: {argb: 'FFFFFFFF'}
            },
            alignment: {horizontal: 'center'},
            fill: {
                
                type: 'pattern',
                pattern: 'solid',
                fgColor: {argb: 'FF2A3761'}
            }
        }; 
    });

    worksheet.columns.forEach(col => {
        col.style = {
            alignment: { horizontal: 'center' }
        };
    });

    
    if (data && data.length > 0) {

        let currentDate = data[0].diaBase;
        worksheet.addRow({
            horaInicial: currentDate,
            evento: 'Inicia el reporte'
        });

        data.forEach(item => {
            //worksheet.addRow(item);

            if (item.diaBase != currentDate) {
                worksheet.addRow({
                    horaInicial: item.diaBase,
                    evento: 'Cambio de fecha'
                });
            }

            currentDate = item.diaBase;

            let row = worksheet.addRow({
                horaInicial: item.horaInicial,
                horaFinal: item.horaFinal,
                diaBase: item.diaBase,
                /*diaInicio: item.diaInicio,
                diaFinal: item.diaFinal,*/
                evento: item.evento,
                lugarVisitado: item.lugarVisitado,
                duracion: item.duracion,
                unidad: item.unidad,
                /*puntoInicial: item.puntoInicial,
                puntoFinal: item.puntoFinal,*/
                ubicacion: item.ubicacion === 'En Transito'? '--' : {text:'Ver en el mapa', hyperlink: `${item.ubicacion}`, },
            })
            
            let linkCell = row.getCell('ubicacion');
            if (item.ubicacion !== 'En Transito'){
                linkCell.style = {
                    font: { color: { argb: 'FF0000FF' }, underline: true },
                    alignment: { horizontal: 'center' }
                };
            }
        });
    
    }

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    saveAs(blob, 'reporteLugaresVisitados.xlsx');
}



/* ----------------------------------------
 Main exported function/component
----------------------------------------*/

export function ReportCreationtPanel () {

    // Default usage states
    const [unitNumber, setUnitNumber] = useState('');
    const [startingDate, setStartingDate] = useState('');
    const [endingDate, setEndingDate] = useState('');
    const [startingTime, setStartingTime] = useState('00:00');
    const [endingTime, setEndingTime] = useState('23:59');
    const [selectedRadio, setSelectedRadio] = useState('0');
    const [validationError, setvalidationError] = useState(' ');

    // Loading / progress states
    const [isLoading, setIsLoading] = useState(false);
    const [progress, setProgress] = useState(0);
    const [progressLabel, setProgressLabel] = useState('');

    const [customCtrls, setCustomCtrls] = useState(false);
    const [allUnits, setAllUnits] = useState(false);
    const [groupLV, setGroupLV] = useState(true);

    // Optional offset states
    const [offsetLV, setOffsetLV] = useState(5);

    const [offsetLat, setOffsetLat] = useState();
    const [offsetLong, setOffsetLong] = useState();
    const [offsetHodo, setOffsetHodo] = useState();
    const [offsetHori, setOffsetHori] = useState();
    const [offsetSpeed, setOffsetSpeed] = useState();


    const updateUnitNumber = (event) => {
        setUnitNumber(event.target.value.trim());
    }

    const updateStartingDate = (event) => {
        setStartingDate(event.target.value);
    };
    const updateStartingTime = (event) => {
        setStartingTime(event.target.value);
    };

    const updateEndingDate = (event) => {
        setEndingDate(event.target.value);
    };
    const updateEndingTime = (event) => {
        setEndingTime(event.target.value);
    };

    const updateRadioValue = (event) => {
        setSelectedRadio(event.target.value);
    };

    const updateLVTime = (event) => {
        setOffsetLV(event.target.value);
    };

    const allUnitsClicked = () => {
        setAllUnits(!allUnits);
        document.getElementById('text-unit-number').disabled = !allUnits;
        document.getElementById('text-unit-number').style.color = allUnits? '#282C34' : '#A8ACB4';

    }


    const setDefaultStyleInputs = () => {
        document.getElementById('text-unit-number').style.backgroundColor = '#EFEFEF';
        document.getElementById('date-start-day').style.backgroundColor = '#EFEFEF';
        document.getElementById('time-start-hour').style.backgroundColor = '#EFEFEF';
        document.getElementById('date-end-day').style.backgroundColor = '#EFEFEF';
        document.getElementById('time-end-hour').style.backgroundColor = '#EFEFEF';
        /*
        document.getElementById('lbl-radio-coords').style.backgroundColor = 'transparent';
        document.getElementById('lbl-radio-odo').style.backgroundColor = 'transparent';
        document.getElementById('lbl-radio-speed').style.backgroundColor = 'transparent';
        */
        setvalidationError(' ');
    }

    const checkIfControlsEmpty = () => {
        let output = true;

        document.getElementById('date-start-day').style.backgroundColor = '#EFA9A9';
        document.getElementById('time-start-hour').style.backgroundColor = '#EFA9A9';
        document.getElementById('date-end-day').style.backgroundColor = '#EFA9A9';
        document.getElementById('time-end-hour').style.backgroundColor = '#EFA9A9';

        if (unitNumber === '' && !allUnits) {
            document.getElementById('text-unit-number').style.backgroundColor = '#EFA9A9';
            output = false;
        }
        if (startingDate === '') {
            document.getElementById('date-start-day').style.backgroundColor = '#EFA9A9';
            output = false;
        }
        if (startingTime === '') {
            document.getElementById('time-start-hour').style.backgroundColor = '#EFA9A9';
            output = false;
        }
        if (endingDate === '') {
            document.getElementById('date-end-day').style.backgroundColor = '#EFA9A9';
            output = false;
        }
        if (endingTime === '') {
            document.getElementById('time-end-hour').style.backgroundColor = '#EFA9A9';
            output = false;
        }
        /*
        if (selectedRadio === '') {
            document.getElementById('lbl-radio-coords').style.backgroundColor = '#EFA9A9';
            document.getElementById('lbl-radio-odo').style.backgroundColor = '#EFA9A9';
            document.getElementById('lbl-radio-speed').style.backgroundColor = '#EFA9A9';
            output = false;
        }
        */
        setvalidationError(output? ' ' : 'Faltan algunos campos de llenar de información');

        return output;
    };

    const validDateTimes = () => {
        let output = true;
        let startDateTime = Date.parse(`${startingDate} ${startingTime}`);
        let endDateTime = Date.parse(`${endingDate} ${endingTime}`);

        setDefaultStyleInputs();

        if(startDateTime > endDateTime){
            setvalidationError('La fecha inicial es mayor a la fecha final');
            document.getElementById('date-start-day').style.backgroundColor = '#EFA9A9';
            document.getElementById('time-start-hour').style.backgroundColor = '#EFA9A9';
            document.getElementById('date-end-day').style.backgroundColor = '#EFA9A9';
            document.getElementById('time-end-hour').style.backgroundColor = '#EFA9A9';
            output = false;
        } else if (startDateTime == endDateTime) {
            setvalidationError('Las fechas final e inicial son iguales');
            document.getElementById('date-start-day').style.backgroundColor = '#EFA9A9';
            document.getElementById('time-start-hour').style.backgroundColor = '#EFA9A9';
            document.getElementById('date-end-day').style.backgroundColor = '#EFA9A9';
            document.getElementById('time-end-hour').style.backgroundColor = '#EFA9A9';
            output = false;
        } else {
            setvalidationError(' ');
        }
        return output;
    };


    const setDefaultVariables = async () => {
        setOffsetLV(5);
        setSelectedRadio('0');
        setGroupLV(true);
    };


    /* ------------------------------------------------------------
    Main function to generate the report
    ------------------------------------------------------------ */
    const generateReport = async () => {
        console.log(` Group? ${groupLV}`);
        setDefaultStyleInputs();
        try {
            if (checkIfControlsEmpty() && validDateTimes()) {
                // --- start progress ---
                setIsLoading(true);
                setProgress(0);
                setProgressLabel('Consultando datos...');

                // Simulate progress from 0 → 70 during the API call
                let currentProgress = 0;
                const progressInterval = setInterval(() => {
                    currentProgress += 1;
                    if (currentProgress <= 70) {
                        setProgress(currentProgress);
                    } else {
                        clearInterval(progressInterval);
                    }
                }, 80);

                let startEpoch = Date.parse(`${startingDate} ${startingTime}`) / 1000;
                let endEpoch = Date.parse(`${endingDate} ${endingTime}`) / 1000;
                let response = await callAPIEventListLV(unitNumber, startEpoch, endEpoch, selectedRadio, (offsetLV * 60), allUnits, groupLV);
                clearInterval(progressInterval);
                // console.log(response);

                if(response.hasOwnProperty('errorTypeCode')) {
                    setvalidationError('Error');
                    console.log('There was an error');
                    setIsLoading(false);
                    setProgress(0);
                } else {
                    setProgress(80);
                    setProgressLabel('Generando Excel...');
                    await generateAndDownloadExcel(response.events);
                    setProgress(100);
                    setProgressLabel('¡Listo!');
                    setTimeout(() => {
                        setIsLoading(false);
                        setProgress(0);
                        setProgressLabel('');
                    }, 800);
                }
                
            }
        } catch (error) {
            setIsLoading(false);
            setProgress(0);
            setProgressLabel('');
            
            if(error.hasOwnProperty('response')) {
                if(error.response.hasOwnProperty('data') && error.response.data.hasOwnProperty('errorTypeCode')) {
                    setvalidationError(error.response.data.message);
                } else {
                    setvalidationError(`Error del Servidor: ${error.response.statusText}`);
                }
            } else if (error.request) {
                // Request made but no response (timeout or connection lost)
                setvalidationError('El servidor tardó demasiado en responder o se perdió la conexión. Intente con un rango de fechas menor.');
            } else {
                setvalidationError(`Error: ${error.message}`);
            }
            console.error('An error ocurred: ', error);
        }

    };



    return (
        <div className={styles.ctrlsContainers}>
            <ul className={styles.ulCtrls}>
                <li className={styles.ctrlsRow}>
                    <div className={styles.divUnit}>
                        <label className={`${styles.lblInput} ${styles.lblVarTitle}`}>Número de Unidad</label>
                        <input id='text-unit-number' type='text' onChange={updateUnitNumber}/>
                    </div>
                </li>
                <li className={styles.ctrlsRowAlt}>
                    <label className={styles.lblAllUnits}>Todos<input type="checkbox" onChange={allUnitsClicked}/></label>
                </li>
                <li className={styles.ctrlsRow}>
                    <div className={styles.divDateTime}>
                        <label className={styles.lblInput}>Fecha Inicial</label>
                        <input id='date-start-day' type='date' value={startingDate} className={styles.inputDateTime} onChange={updateStartingDate}/>
                        <label className={styles.lblInput}>Hora Inicial</label>
                        <input id='time-start-hour' type='time' value={startingTime} className={styles.inputDateTime} onChange={updateStartingTime}/>
                    </div>
                    <div className={styles.divDateTime}>
                        <label className={styles.lblInput}>Fecha Final</label>
                        <input id='date-end-day' type='date' value={endingDate} className={styles.inputDateTime} onChange={updateEndingDate}/>
                        <label className={styles.lblInput}>Hora Final</label>
                        <input id='time-end-hour' type='time' value={endingTime} className={styles.inputDateTime} onChange={updateEndingTime}/>
                    </div>
                </li>
              
            </ul>

            <button id='btn-generate-report' className={styles.btnGenerateReport} onClick={generateReport} disabled={isLoading}>Generar Reporte</button>

            { isLoading && (
                <div className={styles.progressBarContainer}>
                    <div className={styles.progressBarTrack}>
                        <div className={styles.progressBarFill} style={{ width: `${progress}%` }}></div>
                    </div>
                    <label className={styles.lblProgressStatus}>{progressLabel} {progress}%</label>
                </div>
            )}

            <label className={styles.lblValidationError}>{validationError}</label>
            <label className={styles.lblCustomCtrls}>Otras configuraciones
                <input id='cbox-custom-ctrls' className={styles.cboxCustomCtrls} type="checkbox" checked={customCtrls} onChange={() => setCustomCtrls(!customCtrls)}/>  
            </label>
            
            

            { customCtrls && (
                <div className={styles.divOffsets}>
                    <ul className={styles.ulOffsets}>
                        <li className={`${styles.liOffset} ${styles.liOffsetTime}`}>
                            <label className={styles.lblOffset}>Tiempo para Lugar Visitado: </label>
                            <input id="number-lv" type="number"  value={offsetLV} className={styles.inputLV} onChange={updateLVTime} min="1" max="999"></input>
                        </li>

                        <li className={`${styles.liOffset} ${styles.liOffsetIdentificator}`}>
                            <div className={styles.divRadios}>
                                <label className={styles.lblVarTitle}>Calcular evento por: </label>
                                <ul className={styles.ulRadios}>
                                    <li className={styles.liRadio}>
                                        <label id='lbl-radio-coords' className={styles.lblRadio}>
                                            <input type='radio' id='radio-coords' name='differentiatior' value='0' checked={selectedRadio === '0'} onChange={updateRadioValue}
                                            />
                                            Latitud/Longitud
                                        </label>
                                    </li>
                                    <li className={styles.liRadio}>
                                        <label id='lbl-radio-odo' className={styles.lblRadio}>
                                            <input type='radio' id='radio-odo' name='differentiatior' value='1' checked={selectedRadio === '1'} onChange={updateRadioValue}
                                            />
                                            Odómetro
                                        </label>
                                    </li>
                                    <li className={styles.liRadio}>
                                        <label id='lbl-radio-speed' className={styles.lblRadio}>
                                            <input type='radio' id='radio-speed' name='differentiatior' value='3' checked={selectedRadio === '3'} onChange={updateRadioValue}
                                            />
                                            Velocidad
                                        </label>
                                    </li>
                                </ul>
                            </div>
                        </li>

                        <li className={`${styles.liOffset} ${styles.liOffsetGroup}`}>
                            <label className={styles.lblOffset}>Agrupar ubicaciones: </label>
                            <input id='cbox-group-lv' className={styles.cboxGroupLV} type="checkbox" checked={groupLV} onChange={() => setGroupLV(!groupLV)}/>  
                        </li>
                    </ul>
                    <button id='btn-set-default' className={styles.btnSetDefault} onClick={setDefaultVariables}>Valores Default</button>
                </div>
            )}
        
        
        </div>

    );


}










